let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dJiiw")).then(() => parcelRequire('8sMYh'));